/* Recommend a shopping context; only the visitor may submit the localization form. */
(() => {
  const banner = document.getElementById('CountryConfirmation');
  if (!banner || window.Shopify?.designMode) return;
  const form = banner.querySelector('form');
  const country = form.elements.country_code;
  const countryKey = 'rw-localization-country';
  const dismissKey = 'rw-localization-dismissed';
  const read = (kind, key) => {
    try { return window[kind].getItem(key); } catch { return null; }
  };
  const write = (kind, key, value) => {
    try { window[kind].setItem(key, value); } catch { /* Selection still works without storage. */ }
  };
  if (read('localStorage', countryKey) === banner.dataset.country || read('sessionStorage', dismissKey)) return;

  const supported = (select, value) => Array.from(select.options).some(option => option.value === value);
  // Keep Shopify's selected storefront language, including on the root page.
  let touched = false;
  banner.addEventListener('change', () => { touched = true; });
  banner.addEventListener('pointerdown', () => { touched = true; });
  banner.addEventListener('keydown', () => { touched = true; });
  banner.querySelector('[data-dismiss]').addEventListener('click', () => {
    touched = true;
    banner.hidden = true;
    write('sessionStorage', dismissKey, '1');
  });
  form.addEventListener('submit', () => {
    touched = true;
    // A stale ?country=DE would otherwise reapply Germany after the POST to Belgium.
    const target = new URL(window.location.href);
    target.searchParams.delete('country');
    form.elements.return_to.value = target.pathname + target.search + target.hash;
    write('localStorage', countryKey, country.value);
  });
  // Also usable when Shopify cannot recommend a country (one market, blockers, offline).
  banner.hidden = false;
  const root = banner.dataset.root.replace(/\/?$/, '/');
  fetch(`${root}browsing_context_suggestions.json?country%5Benabled%5D=true`, {
    credentials: 'omit', headers: { Accept: 'application/json' },
  })
    .then(response => response.ok ? response.json() : null)
    .then(data => {
      if (touched) return;
      const code = data?.detected_values?.country?.handle?.toUpperCase();
      if (!code || !supported(country, code)) return;
      for (const suggestion of data.suggestions || []) {
        const part = suggestion.parts?.country;
        if (part && (part.handle?.toUpperCase() !== code || !(part.confidence >= 1))) return;
      }
      country.value = code;
    })
    .catch(() => {});
})();
